import { PageContainer } from '@src/shared/components/page-container';
import { PageTitle } from '@src/shared/components/page-title';
import { Activity, TaskSquare } from 'iconsax-react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@src/design-system/tabs';
import { AutomatedRemindersTable } from '../components/all-reminders/automated-reminders/automated-reminders-table';
import { BulkRemindersTable } from '../components/all-reminders/bulk-reminders/bulk-reminders-table';

export const AllRemindersPage = () => {
  return (
    <PageContainer>
      <PageTitle titles={['Reminders', 'All reminders']} />
      <div className='pb-8'>
        <div className='mt-4 rounded-lg border border-primary-200 bg-white pt-2'>
          <Tabs
            defaultValue='automated'
            className='w-full border-0'
          >
            <TabsList className='h-auto pb-0 w-full justify-start gap-8 px-4 pt-0'>
              <TabsTrigger
                value='automated'
                className='inline-flex gap-2 border-0 outline-none'
              >
                <Activity
                  size={20}
                  variant='TwoTone'
                />
                Automated Reminders
              </TabsTrigger>
              <TabsTrigger
                value='bulk'
                className='inline-flex gap-2 border-0 outline-none'
              >
                <TaskSquare
                  size={20}
                  variant='TwoTone'
                />
                Bulk Reminders
              </TabsTrigger>
            </TabsList>
            <TabsContent
              value='automated'
              className='mt-4 px-4'
            >
              <AutomatedRemindersTable />
            </TabsContent>
            <TabsContent
              value='bulk'
              className='mt-4 px-4'
            >
              <BulkRemindersTable />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </PageContainer>
  );
};
